export const valueProps = [
  {
    icon: "ri-radar-line",
    title: "Every lead captured",
    description:
      "Calls answered, chats replied, and forms followed up in seconds. Nothing slips through the cracks, even at 2 AM.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "More meetings booked",
    description:
      "Joble qualifies enquiries and drops confirmed appointments straight into your calendar while you focus on the work.",
  },
  {
    icon: "ri-rocket-2-line",
    title: "Scale without headcount",
    description:
      "Handle 10x the conversations with the same team. No new hires, no burnout, no missed revenue.",
  },
];

export const showcase = [
  {
    heading: "Turn website visitors into customers, automatically",
    eyebrow: "Voice + Web Agent",
    title: "Your website now talks, and sells",
    description:
      "Customers ask questions naturally by voice or text. They explore products, get instant answers, and complete bookings, all inside one conversation.",
    image: "https://joble.app/images/Frame-1.svg",
    imageAlt: "Joble web agent conversation interface",
  },
  {
    heading: "Answer every call. Run every campaign.",
    eyebrow: "Phone Agent",
    title: "Every call answered. Every time. No exceptions.",
    description:
      "Joble guarantees no call goes unanswered. It manages enquiries, books appointments, follows up automatically, and runs large-scale outbound campaigns.",
    image: "https://joble.app/images/Frame-2.svg",
    imageAlt: "Joble phone agent call handling interface",
  },
  {
    heading: "One place. Every conversation. Every action.",
    eyebrow: "Workspace",
    title: "Everything managed from one workspace",
    description:
      "Every interaction becomes a business action. Conversations logged, meetings scheduled, tasks assigned, nothing gets lost in the noise.",
    image: "https://joble.app/images/Frame-3.svg",
    imageAlt: "Joble workspace dashboard with tasks and bookings",
  },
];

export const steps = [
  {
    number: "01",
    title: "Connect",
    description:
      "Paste one line of code or install from the Shopify, WooCommerce, or WordPress app store. No developer, no IT team.",
  },
  {
    number: "02",
    title: "Your agent learns your business",
    description:
      "Products, services, prices, and brand voice are read straight from your site in minutes, not days.",
  },
  {
    number: "03",
    title: "You're live",
    description:
      "Your web agent talks to visitors, your phone agent answers calls, and your workspace shows you everything.",
  },
];

export const stats = [
  { value: "500+", label: "Businesses onboarded" },
  { value: "5 min", label: "Average setup time" },
  { value: "24/7", label: "Always-on coverage" },
  { value: "68%", label: "Fewer missed enquiries" },
];

export const integrations = [
  { icon: "ri-calendar-line", name: "Google Calendar" },
  { icon: "ri-mail-line", name: "Microsoft Outlook" },
  { icon: "ri-cloud-line", name: "Salesforce" },
  { icon: "ri-bubble-chart-line", name: "HubSpot" },
  { icon: "ri-customer-service-2-line", name: "Zendesk" },
  { icon: "ri-whatsapp-line", name: "WhatsApp" },
  { icon: "ri-shopping-bag-3-line", name: "Shopify" },
  { icon: "ri-slack-line", name: "Slack" },
];

export const testimonials = [
  {
    quote:
      "Joble fundamentally changed how we qualify leads. Dropping visitors straight into an interactive agent demo converted more pipeline in a week than our old landing page did all month.",
    name: "Anniek van Veldhuizen",
    role: "CCO & Co-Founder, MyHives",
    avatar: "https://joble.app/images/Anniek.png",
  },
  {
    quote:
      "We went from drowning in support tickets to having Sophia resolve nearly 70% of inbound tier-1 chats instantly. The voice clarity and near-zero latency are remarkable.",
    name: "Marcus Johnson",
    role: "Senior Strategic Advisor",
    avatar: "https://joble.app/images/testimony-2.svg",
  },
  {
    quote:
      "Inbound call drop-off used to be our biggest revenue bottleneck. Joble makes sure every customer gets an immediate, flawless response, even when a surge hits at 2 AM.",
    name: "Joseph Helmy",
    role: "Founder & CEO, Northbay",
    avatar: "https://joble.app/images/testimonial-3.jpg",
  },
  {
    quote:
      "The CRM and helpdesk sync worked flawlessly out of the box. Our engineering team didn't have to spend weeks configuring webhooks or parsing raw transcripts.",
    name: "John Chen",
    role: "VP of Engineering, Loopwire",
    avatar: "https://joble.app/images/testimonial-3.webp",
  },
];

export const faqs = [
  {
    question: "What is Joble?",
    answer:
      "Joble is an AI customer engagement platform with an AI Web Agent for your website, an AI Phone Agent for inbound and outbound calls, and a unified Workspace dashboard. It answers questions, books appointments, captures leads, and runs campaigns automatically, 24/7, in your brand voice.",
  },
  {
    question: "How long does it take to set up Joble?",
    answer:
      "Five minutes for most businesses. That means pasting one line of code on your website, or installing the Shopify, WooCommerce, or WordPress plugin. The Web Agent then reads your catalogue, services, prices, and brand voice directly from your existing site.",
  },
  {
    question: "Do I need a developer or an IT team?",
    answer:
      "No. Joble is designed for founders and small teams. Everything is configured from a visual dashboard, and the agent learns your business automatically from your existing website content.",
  },
  {
    question: "Does it work for my industry?",
    answer:
      "Joble is built for e-commerce and retail, professional services, and hospitality, anywhere a missed enquiry has a direct revenue cost. If your business takes calls or has a website where customers ask questions, Joble fits.",
  },
  {
    question: "Is there really a free trial with no credit card?",
    answer:
      "Yes. You can start your trial in minutes, with no credit card required. Upgrade only when you are ready, and cancel any time.",
  },
];

export const footerLinks = {
  resources: [
    { label: "Products", href: "/products" },
    { label: "Blog", href: "#" },
    { label: "FAQs", href: "#faq" },
    { label: "Help center", href: "#" },
  ],
  company: [
    { label: "About", href: "https://joble.app/en/company" },
    { label: "Careers", href: "#" },
    { label: "Privacy", href: "https://joble.app/en/legal/privacy" },
    { label: "Terms", href: "https://joble.app/en/legal/terms" },
  ],
};